import { Component, Input } from '@angular/core';

/**
 * A downgraded NGX wrapper for the uiTimer directive
 * NOTE: Do not use this wrapper if in NGX; use the directive directly instead
 */
@Component({
	selector: 'ui-timer',
	template: `
		<span [uiTimer]="active" [attr.id]="timerId"></span>
	`,
	standalone: false
})
export class UiTimerWrapperComponent {
	@Input() public timerId?: string | null;
	@Input() public active = true;
}
